module.exports = __webpack_public_path__ + "img/f61.1fd9f5b3.png";